// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Indicator } from './Indicator';
import { iBuildInIndicatorFactory } from './iBuildInIndicatorFactory';
import { ALLIGATOR } from './indicators/ALLIGATOR';
import { AROON } from './indicators/AROON';
import { ATR } from './indicators/ATR';
import { ADX } from './indicators/ADX';
import { AC } from './indicators/AC';
import { AO } from './indicators/AO';
import { DMI } from './indicators/DMI';
import { ADL } from './indicators/ADL';
import { BB } from './indicators/BB';
import { BBF } from './indicators/BBF';
import { BBW } from './indicators/BBW';
import { CCI } from './indicators/CCI';
import { CHANNEL } from './indicators/CHANNEL';
import { DonchianChannel } from './indicators/DonchianChannel';
import { CMO } from './indicators/CMO';
import { Didi } from './indicators/Didi';
import { EMA } from './indicators/EMA';
import { EMACROSS } from './indicators/EMACROSS';
import { FRACTALS3 } from './indicators/Fractals3';
import { FRACTALS5 } from './indicators/Fractals5';
import { HiloEscandina } from './indicators/HiloEscandina';
import { KAMA } from './indicators/KAMA';
import { KELTNER } from './indicators/KELTNER';
import { KRI } from './indicators/KRI';
import { LWMA } from './indicators/LWMA';
import { MACD } from './indicators/MACD';
import { MAE } from './indicators/MAE';
import { MAS3 } from './indicators/MAS3';
import { TEMA } from './indicators/TEMA';
import { TRIX } from './indicators/TRIX';
import { PVT } from './indicators/PVT';
import { VO } from './indicators/VOLUMEOSCILLATOR';
import { DPO } from './indicators/DPO';
import { MD } from './indicators/MD';
import { MovingAverages } from './indicators/MMA';
import { MOMENTUM } from './indicators/MOMENTUM';
import { MultiEMA } from './indicators/MultiEMA';
import { MULTIMOVAVG } from './indicators/MULTIMOVAVG';
import { OBV } from './indicators/OBV';
import { PivotPoint } from './indicators/PivotPoint';
import { PO } from './indicators/PO';
import { PPMA } from './indicators/PPMA';
import { PPO } from './indicators/PPO';
import { QSTICK } from './indicators/QSTICK';
import { REGRESSION } from './indicators/REGRESSION';
import { RLW } from './indicators/RLW';
import { ROC } from './indicators/ROC';
import { RSI } from './indicators/RSI';
import { RSI_LAGUERRE } from './indicators/RSI_LAGUERRE';
import { SAR } from './indicators/SAR';
import { SD } from './indicators/SD';
import { SI } from './indicators/SI';
import { SMA } from './indicators/SMA';
import { WMA } from './indicators/WMA';
import { SMMA } from './indicators/SMMA';
import { STOCHASTIC } from './indicators/STOCHASTIC';
import { STOCHASTICRSI } from './indicators/STOCHASTICRSI';
import { StopATR } from './indicators/StopATR';
import { SUPERTREND } from './indicators/SUPERTREND';
import { SUPERTRENDMTV3 } from './indicators/SUPERTRENDMTV3';
import { TSI } from './indicators/TSI';
import { UO } from './indicators/UO';
import { VOLUME } from './indicators/VOLUME';
import { VWAP } from './indicators/VWAP/VWAP';
import { YHL } from './indicators/YHL';
import { EOM } from './indicators/EOM';
import { MI } from './indicators/MI';
import { MFI } from './indicators/MFI';
import { ZZ } from './indicators/ZZ';
import { PVI } from './indicators/PVI';
import { RVOL } from './indicators/RVOL';
import { RVOLBS } from './indicators/RVOLBS';
import { Resources } from '@shared/localizations/Resources';
import { UUID } from '@shared/utils/UUID';
import { ICH } from './indicators/ICH';
import { HV } from './indicators/HV';
import { iAD } from './indicators/built-in/iAD';
import { iAC } from './indicators/built-in/iAC';
import { iMAEx } from './indicators/built-in/iMAEx';
import { iMA } from './indicators/built-in/iMA';
import { iOBV } from './indicators/built-in/iOBV';
import { iATR } from './indicators/built-in/iATR';
import { iAO } from './indicators/built-in/iAO';
import { iWPR } from './indicators/built-in/iWPR';
import { iSTO } from './indicators/built-in/iSTO';
import { iStdDev } from './indicators/built-in/iStdDev';
import { iSAR } from './indicators/built-in/iSAR';
import { iRVI } from './indicators/built-in/iRVI';
import { iMFI } from './indicators/built-in/iMFI';
import { iBearsPower } from './indicators/built-in/iBearsPower';
import { iMACD } from './indicators/built-in/iMACD';
import { iMom } from './indicators/built-in/iMom';
import { iOsMA } from './indicators/built-in/iOsMA';
import { iADX } from './indicators/built-in/iADX';
import { iAlligator } from './indicators/built-in/iAlligator';
import { iGator } from './indicators/built-in/iGator';
import { iBands } from './indicators/built-in/iBands';
import { iBullsPower } from './indicators/built-in/iBullsPower';
import { iCCI } from './indicators/built-in/iCCI';
import { iBWMFI } from './indicators/built-in/iBWMFI';
import { iDeMarker } from './indicators/built-in/iDeMarker';
import { iEnvelopes } from './indicators/built-in/iEnvelopes';
import { iForce } from './indicators/built-in/iForce';
import { iFractals } from './indicators/built-in/iFractals';
import { iIchimoku } from './indicators/built-in/iIchimoku';
import { IndicatorGroups } from './IndicatorGroups';
class _IndicatorManager {
    constructor() {
        this.IndicatorStorage = {};
        this.InitIndicatorsStorage();
    }
    GetIndicator(ProjectName) {
        let NewIndicator = null;
        if (Resources.isHidden(ProjectName)) {
            return NewIndicator;
        }
        if (!this.IndicatorStorage[ProjectName]) {
            return NewIndicator;
        }
        NewIndicator = new Indicator();
        NewIndicator.Script = new this.IndicatorStorage[ProjectName].Ctor();
        // TODO. Ugly.
        NewIndicator.Script.Indicators = this;
        NewIndicator.Script.iKey = UUID.generateUUIDv5();
        NewIndicator.FillFields();
        return NewIndicator;
    }
    InitIndicatorsStorage() {
        this.IndicatorStorage['McGinley Dynamic'] = {
            Ctor: MD,
            ShortName: 'MD',
            FullName: 'McGinley Dynamic',
            DisplayGroup: IndicatorGroups.MovingAverage
        };
        this.IndicatorStorage.Regression = {
            Ctor: REGRESSION,
            ShortName: 'REGRESSION',
            FullName: 'Regression',
            DisplayGroup: IndicatorGroups.MovingAverage
        };
        this.IndicatorStorage['Smoothed Moving Average'] = {
            Ctor: SMMA,
            ShortName: 'SMMA',
            FullName: 'Smoothed Moving Average',
            DisplayGroup: IndicatorGroups.MovingAverage
        };
        this.IndicatorStorage['Pivot Point Moving Average'] = {
            Ctor: PPMA,
            ShortName: 'PPMA',
            FullName: 'Pivot Point Moving Average',
            DisplayGroup: IndicatorGroups.MovingAverage
        };
        this.IndicatorStorage['Simple Moving Average'] = {
            Ctor: SMA,
            ShortName: 'SMA',
            FullName: 'Simple Moving Average',
            DisplayGroup: IndicatorGroups.MovingAverage
        };
        this.IndicatorStorage['Weighted Moving Average'] = {
            Ctor: WMA,
            ShortName: 'WMA',
            FullName: 'Weighted Moving Average',
            DisplayGroup: IndicatorGroups.MovingAverage
        };
        this.IndicatorStorage['Exponential Moving Average'] = {
            Ctor: EMA,
            ShortName: 'EMA',
            FullName: 'Exponential Moving Average',
            DisplayGroup: IndicatorGroups.MovingAverage
        };
        this.IndicatorStorage['Moving Average/Convergence Divergence'] = {
            Ctor: MACD,
            ShortName: 'MACD',
            FullName: 'Moving Average/Convergence Divergence',
            DisplayGroup: IndicatorGroups.Oscillators
        };
        this.IndicatorStorage['Bollinger Bands Flat'] = {
            Ctor: BBF,
            ShortName: 'BBF',
            FullName: 'Bollinger Bands Flat',
            DisplayGroup: IndicatorGroups.Channels
        };
        this.IndicatorStorage['Bollinger Bands Width'] = {
            Ctor: BBW,
            ShortName: 'BBW',
            FullName: 'Bollinger Bands Width',
            DisplayGroup: IndicatorGroups.Oscillators
        };
        this.IndicatorStorage['Awesome Oscillator'] = {
            Ctor: AO,
            ShortName: 'AO',
            FullName: 'Awesome Oscillator',
            DisplayGroup: IndicatorGroups.Oscillators
        };
        this.IndicatorStorage['Acceleration Oscillator'] = {
            Ctor: AC,
            ShortName: 'AC',
            FullName: 'Acceleration Oscillator',
            DisplayGroup: IndicatorGroups.Oscillators
        };
        this.IndicatorStorage['Detrended Price Oscillator'] = {
            Ctor: DPO,
            ShortName: 'DPO',
            FullName: 'Detrended Price Oscillator',
            DisplayGroup: IndicatorGroups.Oscillators
        };
        this.IndicatorStorage['Bollinger Bands'] = {
            Ctor: BB,
            ShortName: 'BB',
            FullName: 'Bollinger Bands',
            DisplayGroup: IndicatorGroups.Channels
        };
        this.IndicatorStorage.Volume = {
            Ctor: VOLUME,
            ShortName: 'Volume',
            FullName: 'Volume',
            DisplayGroup: IndicatorGroups.Volume
        };
        this.IndicatorStorage['Positive Volume Index'] = {
            Ctor: PVI,
            ShortName: 'PVI',
            FullName: 'Positive Volume Index',
            DisplayGroup: IndicatorGroups.Volume
        };
        this.IndicatorStorage['Volume Weighted Average Price'] = {
            Ctor: VWAP,
            ShortName: 'VWAP',
            FullName: 'Volume Weighted Average Price',
            DisplayGroup: IndicatorGroups.Volume
        };
        this.IndicatorStorage['Relative Strength Index'] = {
            Ctor: RSI,
            ShortName: 'RSI',
            FullName: 'Relative Strength Index',
            DisplayGroup: IndicatorGroups.Oscillators
        };
        this.IndicatorStorage['Price Oscillator'] = {
            Ctor: PO,
            ShortName: 'PO',
            FullName: 'Price Oscillator',
            DisplayGroup: IndicatorGroups.Oscillators
        };
        this.IndicatorStorage.Momentum = {
            Ctor: MOMENTUM,
            ShortName: 'Momentum',
            FullName: 'Momentum',
            DisplayGroup: IndicatorGroups.Oscillators
        };
        this.IndicatorStorage['Commodity Channel Index'] = {
            Ctor: CCI,
            ShortName: 'CCI',
            FullName: 'Commodity Channel Index',
            DisplayGroup: IndicatorGroups.Oscillators
        };
        this.IndicatorStorage.Aroon = {
            Ctor: AROON,
            ShortName: 'Aroon',
            FullName: 'Aroon',
            DisplayGroup: IndicatorGroups.Oscillators
        };
        this.IndicatorStorage['Kairi Relative Index'] = {
            Ctor: KRI,
            ShortName: 'KRI',
            FullName: 'Kairi Relative Index',
            DisplayGroup: IndicatorGroups.Oscillators
        };
        this.IndicatorStorage['Percentage Price Oscillator'] = {
            Ctor: PPO,
            ShortName: 'PPO',
            FullName: 'Percentage Price Oscillator',
            DisplayGroup: IndicatorGroups.Oscillators
        };
        this.IndicatorStorage['%R Larry Williams'] = {
            Ctor: RLW,
            ShortName: 'RLW',
            FullName: '%R Larry Williams',
            DisplayGroup: IndicatorGroups.Oscillators
        };
        this.IndicatorStorage['Rate of Change'] = {
            Ctor: ROC,
            ShortName: 'ROC',
            FullName: 'Rate of Change',
            DisplayGroup: IndicatorGroups.Oscillators
        };
        this.IndicatorStorage.QStick = {
            Ctor: QSTICK,
            ShortName: 'QStick',
            FullName: 'QStick',
            DisplayGroup: IndicatorGroups.Oscillators
        };
        this.IndicatorStorage['True Strength Index and Signal'] = {
            Ctor: TSI,
            ShortName: 'TSI',
            FullName: 'True Strength Index and Signal',
            DisplayGroup: IndicatorGroups.Oscillators
        };
        this.IndicatorStorage['Ultimate Oscillator'] = {
            Ctor: UO,
            ShortName: 'UO',
            FullName: 'Ultimate Oscillator',
            DisplayGroup: IndicatorGroups.Oscillators
        };
        this.IndicatorStorage.TRIX = {
            Ctor: TRIX,
            ShortName: 'TRIX',
            FullName: 'TRIX',
            DisplayGroup: IndicatorGroups.Oscillators
        };
        this.IndicatorStorage.PVT = {
            Ctor: PVT,
            ShortName: 'PVT',
            FullName: 'PVT',
            DisplayGroup: IndicatorGroups.Oscillators
        };
        this.IndicatorStorage.VO = {
            Ctor: VO,
            ShortName: 'VO',
            FullName: 'VO',
            DisplayGroup: IndicatorGroups.Oscillators
        };
        this.IndicatorStorage['Pivot point'] = {
            Ctor: PivotPoint,
            ShortName: 'Pivot point',
            FullName: 'Pivot point',
            DisplayGroup: IndicatorGroups.Trend
        };
        this.IndicatorStorage['Swing Index'] = {
            Ctor: SI,
            ShortName: 'SI',
            FullName: 'Swing Index',
            DisplayGroup: IndicatorGroups.Trend
        };
        this.IndicatorStorage.YHL = {
            Ctor: YHL,
            ShortName: 'YHL',
            FullName: 'YHL',
            DisplayGroup: IndicatorGroups.Trend
        };
        this.IndicatorStorage.ALLIGATOR = {
            Ctor: ALLIGATOR,
            ShortName: 'ALLIGATOR',
            FullName: 'ALLIGATOR',
            DisplayGroup: IndicatorGroups.Trend
        };
        this.IndicatorStorage['3MASignal'] = {
            Ctor: MAS3,
            ShortName: 'MAS3',
            FullName: '3MASignal',
            DisplayGroup: IndicatorGroups.MovingAverage
        };
        this.IndicatorStorage['Triple EMA'] = {
            Ctor: TEMA,
            ShortName: 'TEMA',
            FullName: 'Triple EMA',
            DisplayGroup: IndicatorGroups.MovingAverage
        };
        this.IndicatorStorage['Modified Moving Average'] = {
            Ctor: MovingAverages,
            ShortName: 'MMA',
            FullName: 'Modified Moving Average',
            DisplayGroup: IndicatorGroups.MovingAverage
        };
        this.IndicatorStorage['Stochastic Slow'] = {
            Ctor: STOCHASTIC,
            ShortName: 'STOCHASTIC',
            FullName: 'Stochastic Slow',
            DisplayGroup: IndicatorGroups.Oscillators
        };
        this.IndicatorStorage['Stochastic RSI'] = {
            Ctor: STOCHASTICRSI,
            ShortName: 'STOCHASTICRSI',
            FullName: 'Stochastic RSI',
            DisplayGroup: 'Oscillators'
        };
        this.IndicatorStorage['Historical Volatility'] = {
            Ctor: HV,
            ShortName: 'HV',
            FullName: 'Historical Volatility',
            DisplayGroup: IndicatorGroups.Volatility
        };
        this.IndicatorStorage['On Balance Volume'] = {
            Ctor: OBV,
            ShortName: 'OBV',
            FullName: 'On Balance Volume',
            DisplayGroup: IndicatorGroups.Volume
        };
        this.IndicatorStorage['Ease of Movement'] = {
            Ctor: EOM,
            ShortName: 'EOM',
            FullName: 'Ease of Movement',
            DisplayGroup: IndicatorGroups.Volume
        };
        this.IndicatorStorage['Mass Index'] = {
            Ctor: MI,
            ShortName: 'MI',
            FullName: 'Mass Index',
            DisplayGroup: IndicatorGroups.Oscillators
        };
        this.IndicatorStorage['Money Flow index'] = {
            Ctor: MFI,
            ShortName: 'MFI',
            FullName: 'Money Flow index',
            DisplayGroup: IndicatorGroups.Volume
        };
        this.IndicatorStorage['Relative Volume'] = {
            Ctor: RVOL,
            ShortName: 'RVOL',
            FullName: 'Relative Volume',
            DisplayGroup: IndicatorGroups.Volume
        };
        this.IndicatorStorage['Relative Volume Beasley Savage'] = {
            Ctor: RVOLBS,
            ShortName: 'RVOLBS',
            FullName: 'Relative Volume Beasley Savage',
            DisplayGroup: IndicatorGroups.Volume
        };
        this.IndicatorStorage['Average True Range'] = {
            Ctor: ATR,
            ShortName: 'ATR',
            FullName: 'Average True Range',
            DisplayGroup: IndicatorGroups.Volatility
        };
        this.IndicatorStorage['Chande Momentum Oscillator'] = {
            Ctor: CMO,
            ShortName: 'CMO',
            FullName: 'Chande Momentum Oscillator',
            DisplayGroup: IndicatorGroups.Oscillators
        };
        this.IndicatorStorage['Standard Deviation'] = {
            Ctor: SD,
            ShortName: 'SD',
            FullName: 'Standard Deviation',
            DisplayGroup: IndicatorGroups.Volatility
        };
        this.IndicatorStorage['Parabolic Time/Price System'] = {
            Ctor: SAR,
            ShortName: 'SAR',
            FullName: 'Parabolic Time/Price System',
            DisplayGroup: IndicatorGroups.Trend
        };
        this.IndicatorStorage.ZigZag = {
            Ctor: ZZ,
            ShortName: 'ZZ',
            FullName: 'ZigZag',
            DisplayGroup: IndicatorGroups.Trend
        };
        this.IndicatorStorage['Average Directional Index'] = {
            Ctor: ADX,
            ShortName: 'ADX',
            FullName: 'Average Directional Index',
            DisplayGroup: IndicatorGroups.Trend
        };
        this.IndicatorStorage['Directional Movement Index'] = {
            Ctor: DMI,
            ShortName: 'DMI',
            FullName: 'Directional Movement Index',
            DisplayGroup: IndicatorGroups.Trend
        };
        this.IndicatorStorage['Accumulation Distribution Line'] = {
            Ctor: ADL,
            ShortName: 'ADL',
            FullName: 'Accumulation Distribution Line',
            DisplayGroup: IndicatorGroups.Trend
        };
        this.IndicatorStorage['Keltner Channel'] = {
            Ctor: KELTNER,
            ShortName: 'KELTNER',
            FullName: 'Keltner Channel',
            DisplayGroup: IndicatorGroups.Channels
        };
        this.IndicatorStorage['Price Channel'] = {
            Ctor: CHANNEL,
            ShortName: 'CHANNEL',
            FullName: 'Price Channel',
            DisplayGroup: IndicatorGroups.Channels
        };
        this.IndicatorStorage['Moving Average Envelope'] = {
            Ctor: MAE,
            ShortName: 'MAE',
            FullName: 'Moving Average Envelope',
            DisplayGroup: IndicatorGroups.Channels
        };
        this.IndicatorStorage['Donchian Channel'] = {
            Ctor: DonchianChannel,
            ShortName: 'Donchian Channel',
            FullName: 'Donchian Channel',
            DisplayGroup: IndicatorGroups.Channels
        };
        this.IndicatorStorage['Linear Weighted Moving Average'] = {
            Ctor: LWMA,
            ShortName: 'LWMA',
            FullName: 'Linear Weighted Moving Average',
            DisplayGroup: IndicatorGroups.MovingAverage
        };
        this.IndicatorStorage.Didi = {
            Ctor: Didi,
            ShortName: 'Didi',
            FullName: 'Didi',
            DisplayGroup: IndicatorGroups.Extra
        };
        this.IndicatorStorage.HiloEscandina = {
            Ctor: HiloEscandina,
            ShortName: 'Hilo',
            FullName: 'HiloEscandina',
            DisplayGroup: IndicatorGroups.Extra
        };
        this.IndicatorStorage.StopATR = {
            Ctor: StopATR,
            ShortName: 'StopATR',
            FullName: 'StopATR',
            DisplayGroup: IndicatorGroups.Extra
        };
        this.IndicatorStorage.Fractals3 = {
            Ctor: FRACTALS3,
            ShortName: 'Fractals3',
            FullName: 'Fractals3',
            DisplayGroup: IndicatorGroups.Trend
        };
        this.IndicatorStorage.Fractals5 = {
            Ctor: FRACTALS5,
            ShortName: 'Fractals5',
            FullName: 'Fractals5',
            DisplayGroup: IndicatorGroups.Trend
        };
        this.IndicatorStorage.Ichimoku = {
            Ctor: ICH,
            ShortName: 'ICH',
            FullName: 'Ichimoku',
            DisplayGroup: IndicatorGroups.Trend
        };
        this.IndicatorStorage['Kaufman adaptive moving average'] = {
            Ctor: KAMA,
            ShortName: 'KAMA',
            FullName: 'Kaufman adaptive moving average',
            DisplayGroup: IndicatorGroups.MovingAverage
        };
        this.IndicatorStorage['Multi EMA'] = {
            Ctor: MultiEMA,
            ShortName: 'MultiEMA',
            FullName: 'Multi EMA',
            DisplayGroup: IndicatorGroups.MovingAverage
        };
        this.IndicatorStorage['Self-Adjusting Alpha with Fractals Energy'] = {
            Ctor: RSI_LAGUERRE,
            ShortName: 'RSI Laguerre',
            FullName: 'Self-Adjusting Alpha with Fractals Energy',
            DisplayGroup: IndicatorGroups.Oscillators
        };
        let tag = 'SUPER TREND';
        this.IndicatorStorage[tag] = {
            Ctor: SUPERTREND,
            ShortNameLocKey: `${tag}.ShortName`,
            FullNameLocKey: `${tag}.FullName`,
            ShortName: tag,
            FullName: tag,
            DisplayGroup: IndicatorGroups.Custom
        };
        tag = 'EMA CROSS';
        this.IndicatorStorage[tag] = {
            Ctor: EMACROSS,
            ShortNameLocKey: `${tag}.ShortName`,
            FullNameLocKey: `${tag}.FullName`,
            ShortName: tag,
            FullName: tag,
            DisplayGroup: IndicatorGroups.Custom
        };
        tag = 'MULTIMOV AVG';
        this.IndicatorStorage[tag] = {
            Ctor: MULTIMOVAVG,
            ShortNameLocKey: `${tag}.ShortName`,
            FullNameLocKey: `${tag}.FullName`,
            ShortName: tag,
            FullName: tag,
            DisplayGroup: IndicatorGroups.Custom
        };
        tag = 'SUPERTREND MTV3';
        this.IndicatorStorage[tag] = {
            Ctor: SUPERTRENDMTV3,
            ShortNameLocKey: `${tag}.ShortName`,
            FullNameLocKey: `${tag}.FullName`,
            ShortName: tag,
            FullName: tag,
            DisplayGroup: IndicatorGroups.Custom
        };
    }
    GetIndicatorItemsList() {
        const itemsArray = [];
        const indObjs = Object.keys(this.IndicatorStorage);
        const len = indObjs.length;
        for (let i = 0; i < len; i++) {
            const cItem = this.IndicatorStorage[indObjs[i]];
            if (Resources.isHidden(cItem.FullName)) {
                continue;
            }
            itemsArray.push({
                FullName: cItem.FullName,
                FullNameLocKey: cItem.FullNameLocKey,
                DisplayGroup: cItem.DisplayGroup,
                ShortName: cItem.ShortName,
                ShortNameLocKey: cItem.ShortNameLocKey
            });
        }
        return itemsArray;
    }
    // TODO. Ugly.
    createBuiltInIndicator(name, args, options) {
        const historicalData = options ? options.historicalData : null;
        const dataOnArrayFunc = options ? options.dataOnArrayFunc : null;
        const ind = iBuildInIndicatorFactory.CreateIndicator(name, args);
        if (ind && dataOnArrayFunc && (historicalData === null || historicalData === void 0 ? void 0 : historicalData.Indicator)) {
            ind.PriceData = new FuncWrapper(dataOnArrayFunc, historicalData.Indicator);
        }
        return ind;
    }
    // TODO.
    // #region Built-in Indicator
    // TODO. Ugly.
    iMA(par0, par1, par2, par3, par4) {
        if (par0 !== undefined &&
            par1 !== undefined &&
            par2 !== undefined &&
            par3 === undefined &&
            par4 === undefined) {
            return this.createBuiltInIndicator(iMA, [par1, par2]);
        }
        if (par0 !== undefined &&
            par1 !== undefined &&
            par2 !== undefined &&
            par3 !== undefined &&
            par4 !== undefined) {
            return this.createBuiltInIndicator(iMAEx, [par1, par2, par3, par4]);
        }
    }
    // TODO. Ugly.
    iMAOnArray(historicalData, dataOnArrayFunc, period, mode) {
        const ima = this.createBuiltInIndicator(iMA, [period, mode], {
            historicalData,
            dataOnArrayFunc
        });
        return ima;
    }
    iMAExOnArray(historicalData, dataOnArrayFunc, period, mode, maShift, startWithBarIndex) {
        const ima = this.createBuiltInIndicator(iMAEx, [period, mode, maShift, 1, startWithBarIndex], {
            historicalData,
            dataOnArrayFunc
        });
        return ima;
    }
    // TODO. Ugly.
    iOBV(data, priceType) {
        return this.createBuiltInIndicator(iOBV, [priceType]);
    }
    // TODO. Ugly.
    iAD(data) {
        return this.createBuiltInIndicator(iAD);
    }
    // TODO. Ugly.
    iATR(data, maPeriod, maMode) {
        return this.createBuiltInIndicator(iATR, [maPeriod, maMode]);
    }
    // TODO. Ugly.
    iAO(data) {
        return this.createBuiltInIndicator(iAO);
    }
    iAC(data) {
        return this.createBuiltInIndicator(iAC);
    }
    // TODO. Ugly.
    iWPR(data, priceType) {
        return this.createBuiltInIndicator(iWPR, [priceType]);
    }
    // TODO. Ugly.
    iSTO(data, kPeriod, dPeriod, slowing, maMode, priceField) {
        return this.createBuiltInIndicator(iSTO, [kPeriod, dPeriod, slowing, maMode, priceField]);
    }
    // TODO. Ugly.
    iStdDev(data, period, maMethod, shift, priceType) {
        return this.createBuiltInIndicator(iStdDev, [period, maMethod, shift, priceType]);
    }
    // TODO. Ugly.
    iSAR(data, step, maximum) {
        return this.createBuiltInIndicator(iSAR, [step, maximum]);
    }
    // TODO. Ugly.
    iRVI(data, maPeriod, maMode) {
        return this.createBuiltInIndicator(iRVI, [maPeriod, maMode]);
    }
    // TODO. Ugly.
    iMFI(data, mfiPeriod) {
        return this.createBuiltInIndicator(iMFI, [mfiPeriod]);
    }
    // TODO. Ugly.
    iBearsPower(data, period, priceType) {
        return this.createBuiltInIndicator(iBearsPower, [period, priceType]);
    }
    // TODO. Ugly.
    iMACD(data, fastMaPeriod, slowMaPeriod, signalPeriod) {
        return this.createBuiltInIndicator(iMACD, [fastMaPeriod, slowMaPeriod, signalPeriod]);
    }
    // TODO. Ugly.
    iMom(data, momPeriod, priceType) {
        return this.createBuiltInIndicator(iMom, [momPeriod, priceType]);
    }
    // TODO. Ugly.
    iOsMA(data, fastMAPeriod, slowMaPeriod, signalPeriod, priceType) {
        return this.createBuiltInIndicator(iOsMA, [fastMAPeriod, slowMaPeriod, signalPeriod, priceType]);
    }
    // TODO. Ugly.
    iADX(data, maPeriod, priceType, maMode) {
        return this.createBuiltInIndicator(iADX, [maPeriod, priceType, maMode]);
    }
    // TODO. Ugly.
    iAlligator(data, jawPeriod, jawShift, teethPeriod, teethShift, lipsPeriod, lipsShift, maMode, priceType) {
        return this.createBuiltInIndicator(iAlligator, [
            jawPeriod,
            jawShift,
            teethPeriod,
            teethShift,
            lipsPeriod,
            lipsShift,
            maMode,
            priceType
        ]);
    }
    // TODO. Ugly.
    iGator(data, jawPeriod, jawShift, teethPeriod, teethShift, lipsPeriod, lipsShift, maMode, priceType) {
        return this.createBuiltInIndicator(iGator, [
            jawPeriod,
            jawShift,
            teethPeriod,
            teethShift,
            lipsPeriod,
            lipsShift,
            maMode,
            priceType
        ]);
    }
    // TODO. Ugly.
    iBands(data, maPeriod, maMode, deviation, bandsShift) {
        return this.createBuiltInIndicator(iBands, [maPeriod, maMode, deviation, bandsShift]);
    }
    // TODO. Ugly.
    iBullsPower(data, maPeriod, priceType) {
        return this.createBuiltInIndicator(iBullsPower, [maPeriod, priceType]);
    }
    // TODO. Ugly.
    iCCI(data, maPeriod, maMode) {
        return this.createBuiltInIndicator(iCCI, [maPeriod, maMode]);
    }
    // TODO. Ugly.
    iBWMFI(data) {
        return this.createBuiltInIndicator(iBWMFI);
    }
    // TODO. Ugly.
    iDeMarker(data, maPeriod) {
        return this.createBuiltInIndicator(iDeMarker, [maPeriod]);
    }
    // TODO. Ugly.
    iEnvelopes(data, maPeriod, maMethod, maShift, deviation, priceType) {
        return this.createBuiltInIndicator(iEnvelopes, [maPeriod, maMethod, maShift, deviation, priceType]);
    }
    // TODO. Ugly.
    iForce(data, maPeriod, maMethod, priceType) {
        return this.createBuiltInIndicator(iForce, [maPeriod, maMethod, priceType]);
    }
    // TODO. Ugly.
    iFractals(data) {
        return this.createBuiltInIndicator(iFractals);
    }
    // TODO. Ugly.
    iIchimoku(data, tenkanSen, kijunSen, senkouSpanB) {
        return this.createBuiltInIndicator(iIchimoku, [tenkanSen, kijunSen, senkouSpanB]);
    }
}
// #region FuncWrapper
class FuncWrapper {
    constructor(func, indicator) {
        this._func = func;
        this._indicator = indicator;
    }
    // #region IDoubleVector Members
    get(index) {
        return this._func(this.Length - index - 1);
    }
    set(index, value) { }
    get Length() {
        // лайв стратегия имеет каунт 0, беру каунт кешайтема.
        // Для БТ стратегии они равны, а для индикатора нужно брать его каунт.
        // TODO. Strategy.
        return this._indicator.FCount;
    }
    // #endregion IDoubleVector Members
    Dispose() {
        this._func = null;
        this._indicator = null;
    }
}
// #endregion FuncWrapper
export const IndicatorManager = new _IndicatorManager();
